import withUser from '~lib/common/hoc/withUser';

import OrgUsers from './OrgUsers';

export default withUser()(OrgUsers);
